/* eslint-disable no-underscore-dangle, no-param-reassign */
import Immutable from 'immutable';
import Cookies from 'js-cookie';

const PLAYBACK_RATE_COOKIE_NAME = 'preferred_playback_rate';
const PLAYBACK_VOLUME_COOKIE_NAME = 'preferred_playback_volume';
const CAPTIONS_VISIBLE_COOKIE_NAME = 'preferred_captions_visibility';
const SET_VIDEO_PLAYBACK_RATE = 'edrolo/video/SET_VIDEO_PLAYBACK_RATE';
const SET_VIDEO_PLAYBACK_VOLUME = 'edrolo/video/SET_VIDEO_PLAYBACK_VOLUME';
const SET_CAPTIONS_VISIBLE = 'edrolo/video/SET_CAPTIONS_VISIBLE';
const ADD_VIDEO_ELEMENT = 'edrolo/video/ADD_VIDEO_ELEMENT';

const getFloatFromCookie = (cookieName, defaultValue = 1) => {
  const rate = parseFloat(Cookies.get(cookieName));
  return !isNaN(rate) ? rate : defaultValue;
};

const getBooleanFromCookie = (cookieName, defaultValue = false) => {
  // Any stored value other than the string "true" will return false.
  const cookieValue = Cookies.get(cookieName);
  if (typeof cookieValue === 'undefined') {
    return defaultValue;
  }
  return cookieValue === 'true';
};

const defaultState = Immutable.fromJS({
  playbackRate: getFloatFromCookie(PLAYBACK_RATE_COOKIE_NAME),
  playbackVolume: getFloatFromCookie(PLAYBACK_VOLUME_COOKIE_NAME),
  captionsVisible: getBooleanFromCookie(CAPTIONS_VISIBLE_COOKIE_NAME),
  videoElements: {},
});

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_VIDEO_PLAYBACK_RATE:
      return state.set('playbackRate', action.rate);

    case SET_VIDEO_PLAYBACK_VOLUME:
      return state.set('playbackVolume', action.level);

    case SET_CAPTIONS_VISIBLE:
      return state.set('captionsVisible', action.visible);

    case ADD_VIDEO_ELEMENT:
      return state.update('videoElements', (videoElements) =>
        videoElements.set(action.videoElement.id, action.videoElement)
      );
    default:
      return state;
  }
};

const updateAllVideos = (updater) => (dispatch, getState) => {
  const state = getState().video;
  const videos = state.get('videoElements');
  videos.forEach(updater);
};

export const setPlaybackRate = (rate) => (dispatch, getState) => {
  // set as cookie
  Cookies.set(PLAYBACK_RATE_COOKIE_NAME, rate, { expires: 30, path: '/' });

  // set speed of all loaded videos
  dispatch(
    updateAllVideos((videoElement) => {
      videoElement.playbackRate = rate;
    })
  );

  dispatch({
    type: SET_VIDEO_PLAYBACK_RATE,
    rate,
  });
};

export const setPlaybackVolume = (level) => (dispatch) => {
  // set as cookie
  Cookies.set(PLAYBACK_VOLUME_COOKIE_NAME, level, { expires: 30, path: '/' });

  // set volume of all loaded videos
  dispatch(
    updateAllVideos((videoElement) => {
      videoElement.volume = level;
    })
  );

  dispatch({
    type: SET_VIDEO_PLAYBACK_VOLUME,
    level,
  });
};

export const setCaptionsVisible = (visible) => (dispatch) => {
  // set as cookie
  // NOTE cookie stores "true" and "false" as strings!
  Cookies.set(CAPTIONS_VISIBLE_COOKIE_NAME, visible, {
    expires: 30,
    path: '/',
  });

  dispatch({
    type: SET_CAPTIONS_VISIBLE,
    visible,
  });
};

export const addVideoElement = (videoElement) => (dispatch, getState) => {
  // set this video to the global playback speed and volume
  const state = getState().video;
  videoElement.playbackRate = state.get('playbackRate');
  videoElement.volume = state.get('playbackVolume');

  dispatch({
    type: ADD_VIDEO_ELEMENT,
    videoElement,
  });
};

export const actions = {
  setPlaybackRate,
  setPlaybackVolume,
  setCaptionsVisible,
  addVideoElement,
};
